<template>
    <div class="_content">
        <div class="accountAccessPic" >
            <img src="~@/imgs/accountAccessPic.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
}
</script>
<style lang="less" scoped>
    ._content{
        background: #fff;
    }
    .accountAccessPic{
    display: flex;
    justify-content: center;
    margin: .5rem 0;
        >img{
            width: 17rem;
            height: 15rem;
        }
    } 
    
</style>


// WEBPACK FOOTER //
// src/pages/accountAccessPic/index.vue